import React from "react";
import { Box, Typography } from "@mui/material";
import { InvoiceDataType } from "../../../api/invoice";
import * as styles from "./InvoiceDetails5Styles"; // Import styles

interface InvoiceDetails5Props {
  showOnlyPlaceOfSupply?: boolean;
  showClientDetails?: boolean;
  showBillToService?: boolean;
  showBankInfo?: boolean;
  data?: InvoiceDataType;
}

const InvoiceDetails5: React.FC<InvoiceDetails5Props> = ({
  showOnlyPlaceOfSupply = false,
  showClientDetails = false,
  showBankInfo = false,
  showBillToService = false,
  data,
}) => {
  const billToData = {
    ...data?.billTo,
    GST: data?.billTo?.licenseGSTNumber,
    stateCode: data?.billTo?.gstStateCode,
    PAN: data?.billTo?.licensePANNumber,
  };
  const placeOfSupplyData = data?.excise?.placeOfSupply ?? "";
  const bankDetailsData = data?.bank;
  const clientDetails = data?.other;
  const clientRegisteredAddress = data?.other;

  if (showBillToService) {
    return (
      <Box>
        <Typography variant="h6" sx={styles.sectionTitle}>
          CLIENT DETAILS
        </Typography>
        <Box sx={{ padding: "3px" }}>
          <Typography variant="body1" sx={styles.clientDetailText}>
            {clientDetails?.outletName}
          </Typography>
          <Typography variant="body1" sx={styles.clientDetailText}>
            {clientRegisteredAddress?.registeredAddress ?? ""}
          </Typography>
        </Box>
      </Box>
    );
  }

  if (showOnlyPlaceOfSupply) {
    // Render only the "Place of Supply" section for Excise Invoice screen
    return (
      <Box>
        <Typography
          variant="h6"
          sx={styles.sectionTitle}
          data-testid="place-of-supply-title"
        >
          PLACE OF SUPPLY
        </Typography>
        <Box sx={{ padding: "3px" }}>
          <Typography
            variant="body1"
            sx={{ ...styles.bodyText, whiteSpace: "pre-line" }}
          >
            {placeOfSupplyData}
          </Typography>
        </Box>
      </Box>
    );
  }

  if (showClientDetails) {
    // Render only the "Client Details" section for Service Invoice screen
    return (
      <Box>
        <Typography variant="h6" sx={styles.sectionTitle}>
          CLIENT DETAILS
        </Typography>
        <Box sx={{ padding: "3px" }}>
          <Typography variant="body1" sx={styles.clientDetailText}>
            <span
              style={{
                fontSize: "10px",
                fontWeight: 500,
              }}
            >
              PAN:{" "}
            </span>
            {clientDetails?.clientPAN}
          </Typography>
          <Typography variant="body1" sx={styles.clientDetailText}>
            <span
              style={{
                fontSize: "10px",
                fontWeight: 500,
              }}
            >
              GST:{" "}
            </span>
            {clientDetails?.clientGST}
          </Typography>
          <Typography variant="body1" sx={styles.clientDetailText}>
            <span
              style={{
                fontSize: "10px",
                fontWeight: 500,
              }}
            >
              GST State Code:{" "}
            </span>
            {clientDetails?.clientGSTStateCode}
          </Typography>
        </Box>
      </Box>
    );
  }

  if (showBankInfo) {
    // Render only the "Bank Details" section for Service Invoice screen
    return (
      <Box>
        <Typography variant="body1" sx={styles.bankDetailText}>
          <span
            style={{
              fontSize: "10px",
              fontWeight: 500,
            }}
          >
            Account Name:{" "}
          </span>
          {bankDetailsData?.accountName}
        </Typography>
        <Typography variant="body1" sx={styles.bankDetailText}>
          <span
            style={{
              fontSize: "10px",
              fontWeight: 500,
            }}
          >
            Account Number:{" "}
          </span>
          {bankDetailsData?.accountNumber}
        </Typography>
        <Typography variant="body1" sx={styles.bankDetailText}>
          <span
            style={{
              fontSize: "10px",
              fontWeight: 500,
            }}
          >
            Bank Name:{" "}
          </span>
          {bankDetailsData?.name}
        </Typography>
        <Typography variant="body1" sx={styles.bankDetailText}>
          <span
            style={{
              fontSize: "10px",
              fontWeight: 500,
            }}
          >
            Branch:{" "}
          </span>
          {bankDetailsData?.branchCode}
        </Typography>
        <Typography variant="body1" sx={styles.bankDetailText}>
          <span
            style={{
              fontSize: "10px",
              fontWeight: 500,
            }}
          >
            IFSC:{" "}
          </span>
          {bankDetailsData?.ifscCode}
        </Typography>
      </Box>
    );
  }

  // Default: Render the full component
  return (
    <Box>
      <Typography variant="h6" sx={styles.sectionTitle}>
        BILL TO
      </Typography>
      <Box sx={{ padding: "3px" }}>
        <Typography variant="body1" sx={styles.bodyText}>
          <span
            style={{
              fontSize: "10px",
              fontWeight: 500,
            }}
          >
            License Name:{" "}
          </span>
          {billToData?.licenseName}
        </Typography>
        <Typography variant="body1" sx={styles.bodyText}>
          <span
            style={{
              fontSize: "10px",
              fontWeight: 500,
            }}
          >
            License Address:{" "}
          </span>
          {billToData?.licenseAddress}
        </Typography>
        <Typography variant="body1" sx={styles.bodyText}>
          <span
            style={{
              fontSize: "10px",
              fontWeight: 500,
            }}
          >
            PAN:{" "}
          </span>
          {billToData?.PAN}
        </Typography>
        <Typography variant="body1" sx={styles.bodyText}>
          <span
            style={{
              fontSize: "10px",
              fontWeight: 500,
            }}
          >
            GST:{" "}
          </span>
          {billToData.GST}
        </Typography>
        <Typography variant="body1" sx={styles.bodyText}>
          <span
            style={{
              fontSize: "10px",
              fontWeight: 500,
            }}
          >
            State Code:{" "}
          </span>
          {billToData.stateCode}
        </Typography>
      </Box>
    </Box>
  );
};

export default InvoiceDetails5;
